module.exports = __webpack_public_path__ + "img/level_logo4.143a6ea7.png";